module.exports = __webpack_public_path__ + "static/pattern-design-03-37a6d2d0f06acd6976dfbdc3036d4851.jpg";